import React from "react";

export const MAX_TEXT_LENGTH = 500;

/**
 * 텍스트 길이에 따라 색상을 다르게 렌더링하는 함수
 * @param {string} text - 입력된 텍스트
 * @param {number} maxLength - 최대 허용 길이 (기본값: 500)
 * @returns {JSX.Element|null} 색상이 적용된 텍스트 요소
 */
export const renderTextWithColor = (text, maxLength = MAX_TEXT_LENGTH) => {
  if (!text) return null;
  
  if (text.length <= maxLength) {
    return <span style={{ color: "#000" }}>{text}</span>;
  }
  
  const normalText = text.substring(0, maxLength);
  const overLimitText = text.substring(maxLength);
  
  return (
    <>
      <span style={{ color: "#000" }}>{normalText}</span>
      <span style={{ color: "#e03131" }}>{overLimitText}</span>
    </>
  );
};

/**
 * 텍스트가 제한을 초과했는지 확인하는 함수
 * @param {string} text - 확인할 텍스트
 * @param {number} maxLength - 최대 허용 길이
 * @returns {boolean} 초과 여부
 */
export const isTextOverLimit = (text, maxLength = MAX_TEXT_LENGTH) => {
  return text && text.length > maxLength;
}; 